import { useState, useEffect } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import React from 'react'
import { Schema, Form } from 'rsuite';
import BlockUi from '@availity/block-ui';
import Swal from 'sweetalert2';
import boardCommentsService from '../../../services/Shared/boardComments.service';
import TextArea from '../GenericComponents/TextArea';

function AddBoardMemberCommentModal(props) {
    const { StringType } = Schema.Types;
    const [blockUi, setBlockUi] = useState(false);
    const [modelData, setModelData] = useState();
    const model = Schema.Model({
        comment: StringType().isRequired('This field is required.'),
    })
    useEffect(() => {
        setModelData(props.modalData);
    }, [props.modalData])

    const formSubmit = (validation, event) => {
        if (validation) {
            setBlockUi(true);
            boardCommentsService.postBoardComment(modelData).then((response) => {
                setBlockUi(false)
                Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true,
                    iconColor: 'white',
                    customClass: {
                        popup: 'colored-toast',
                    }
                }).fire({
                    icon: "success",
                    title: "Comment Saved"
                });
                props.refreshComments();
                props.onHide();
            });

        }
    }
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            animation={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <BlockUi blocking={blockUi}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add A Comment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form model={model} id="boardForm" formValue={modelData} onChange={data => setModelData(data)} onSubmit={formSubmit} fluid>
                        <Form.Group className='mx-3'>
                            <Row>
                                <Col>
                                    <Form.Control rows={5} accepter={TextArea} name="comment" />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" form="boardForm" variant="primary">Submit</Button>
                    <Button variant="danger" onClick={props.onHide}>Cancel</Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
    );
}

export default AddBoardMemberCommentModal;